import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ArticleCtaSection() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-7xl px-4 pb-14 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-2xl bg-primary-500 px-6 py-12 md:px-12 md:py-16">
        <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-background-50/10"></div>
        <div className="absolute -bottom-16 -left-10 h-56 w-56 rounded-full bg-background-50/10"></div>

        <div className="relative z-10 flex flex-col items-start justify-between gap-6 md:flex-row md:items-center">
          <div className="max-w-xl">
            <span className="inline-block rounded-full bg-background-50/20 px-3 py-1 text-xs font-semibold text-background-50">
              {t("articleCta.note")}
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-background-50 md:text-3xl">
              {t("articleCta.title")}
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-background-50/90 md:text-base">
              {t("articleCta.subtitle")}
            </p>
          </div>

          <Link
            to="/usfans-spreadsheet-guide"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-semibold text-foreground-950 transition-colors hover:bg-background-100"
          >
            {t("articleCta.button")}
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
}